import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared.module';
import { VisitorHandlerComponent } from './visitors-login-management/visitors-login-management.component';
import { OtpHandlerComponent } from './otp-handler/otp-handler.component';
import { PublicRoutingModule } from './public-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ManikAutoCompleteLoader, ManikDataLoaderComponent, ManikLoaderComponent } from 'src/manik-library/manik-loader/manik-loader.component';



@NgModule({
  declarations: [
    VisitorHandlerComponent,
    OtpHandlerComponent,
    ManikAutoCompleteLoader,
    ManikDataLoaderComponent,
    ManikLoaderComponent
  ],
  imports: [
    CommonModule,
   // SharedModule,
    PublicRoutingModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [ManikLoaderComponent, ManikDataLoaderComponent, ManikAutoCompleteLoader, VisitorHandlerComponent]
})
export class PublicModule { }
